import { ActionField, withForm } from '@oscar/form';
import { Button, Modal, Typography, notification } from '@oscar/theme';
import { APIS } from 'common/constants/endpoints';
import React from 'react';

const { Title } = Typography;

export type DeletePopupServiceProps = {
  isVisible: boolean;
  handleCancel: () => void;
  record?: any;
  actionTable?: any;
};

const DeletePopupService: React.FC<DeletePopupServiceProps> = ({
  isVisible,
  handleCancel,
  record,
  actionTable,
}) => {
  const showMessage = (code: number) => {
    if (code === 1) {
      notification['success']({
        message: 'Successfully!',
        description: 'Service Provider has been deleted',
      });
    }
    if (code === 2) {
      notification['error']({
        message: 'Delete Service provider Error',
      });
    }
  };

  return (
    <ActionField
      name={'deleteServiceProvider'}
      request={{
        name: 'Save',
        url: APIS.DELETE_SERVICES_PROVIDER,
        method: 'DELETE',
        params: {
          servicesID: record?.id,
        },
      }}
      onResponseData={(res: any) => {
        showMessage(res?.code);
        if (res?.code === 1) {
          actionTable?.fetchData?.({});
          handleCancel();
        }
      }}
    >
      {(actionProps: any) => {
        return (
          <Modal
            className="popup-custom"
            title="Delete confirmation"
            maskTransitionName=""
            visible={isVisible}
            onCancel={() => handleCancel()}
            footer={[
              <Button size="middle" key="back" onClick={() => handleCancel()}>
                Cancel
              </Button>,
              <Button
                className="btn-submit"
                size="middle"
                key="submit"
                onClick={() => {
                  actionProps.submitData();
                }}
              >
                Confirm
              </Button>,
            ]}
          >
            <Title level={5}>
              Are you sure you want to delete this company?
            </Title>
          </Modal>
        );
      }}
    </ActionField>
  );
};

export default withForm<DeletePopupServiceProps>({
  name: 'company',
  preload: [],
})(DeletePopupService);
